import React from 'react';
import { useTranslation } from 'react-i18next';

const NewContentChip = (props) => {
    const { t } = useTranslation();
    const { isShowNewChip, brandingHilightColor } = props;

    if (isShowNewChip) {
        return (<div
            style={{ backgroundColor: brandingHilightColor }}
            className="engagement-viewer-new-content-chip">
            <span>{t('LIVE_SEND_VIEWER_NEW')}</span>
        </div>
        );
    }

    return null;
};

export default NewContentChip;
